export default __webpack_public_path__ + "b185115638320c3f5c5ff8cf5b21982a.svg";